<template>
    <div class="auth-layout">
        <slot></slot>
    </div>
</template>

<style scoped>
:deep(.logged-out-container) {
    position: relative;
    background-color: #f3f4f6;
    isolation: isolate;
}

:deep(.welcome-back) {
    font-family: FMBolyarSansPro;
    font-size: 22px;
    color: #FFFFFF;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.50);
}

:deep(.font-bolyar) {
    font-family: FMBolyarSansPro;
}

:deep(.larger-letter) {
    font-size: 1.2em; /* Adjust the size as needed */
    display: inline-block; /* Ensures the size change doesn't affect line height */
}
</style>